import Request from "../handleRequest/Request";
const login = "/auth/login";
const me = "/me";
const userAvatar = "me/avatar";
const resetRequest = "/auth/password-reset-request";
const setPassword = "/auth/password-reset";

export default {

  login(data) {
    return Request.post(login, data)
      .then((res) => res)
      .catch((err) => { throw err; });
  },
  Me() {
    return Request.get(me, "")
      .then((res) => res)
      .catch((err) => {
        throw err;
      });
  },
  getMeta() {
    return Request.get("/api/meta", "")
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  },
  updateMeta(data) {
    return Request.patch("/api/meta", data)
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  },
  updateMe(data) {
    return Request.post(me, data)
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  },
  uploadAvatar(data) {
    return Request.uploadFile(userAvatar, data)
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  },

  restPassword(data) {
    return Request.post(resetRequest, data)
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  },
  setPassword(data) {
    return Request.post(setPassword, data)
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  },
  updatePassword(data) {
    return Request.put(me, data)
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  },
};
